import React, { useState } from "react";
import styled from "styled-components";
// import img_book_math from "../assets/img_book_math.png";
import img_book_kor from "../img/img_book_kor.png";
import img_book_eng from "../img/img_book_eng.png";
import img_book_math from "../img/img_book_math.png";
import HamburgerButton from "../img/hamburger_btn.png";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Sidebar from "../components/Sidebar";

const Container = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MyBooksContainer = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  height: 100dvh;
  display: flex;
  flex-direction: column;

  @media (min-width: 640px) {
    max-width: 448px;
  }
`;

const Header = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #333;
  margin-bottom: 4px;
`;

const BooksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
  overflow-y: auto;
  flex: 1;
`;

const BookCard = styled.div`
  display: flex;
  gap: 16px;
  padding: 12px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
`;

const BookImage = styled.img`
  width: 100px;
  height: 140px;
  object-fit: cover;
  border-radius: 8px;
`;

const BookInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const BookTitle = styled.h3`
  font-size: 16px;
  margin: 0 0 8px 0;
  color: #333;
`;

const BookDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
`;

const AddBookCard = styled(BookCard)`
  justify-content: center;
  align-items: center;
  height: 80px;
  border: 2px dashed #ddd;
  background-color: #f5f5f5;

  &:hover {
    background-color: #eee;
  }
`;

const PlusIcon = styled.div`
  font-size: 24px;
  color: #666;
`;

const MyBooks = ({ handleLogout, nickname, setNickname }) => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentAgent] = useState("고등수학 에이전트");

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const changeAgent = (newAgent) => {
    Swal.fire({
      title: "🤖",
      text: "현재는 고등수학 에이전트만 사용 가능합니다",
      icon: "info",
      confirmButtonText: "알겠어요!",
      confirmButtonColor: "#7950F2",
      background: "#fff",
      width: "280px",
      padding: "10px",
      customClass: {
        popup: "rounded-2xl",
        title: "text-xl mb-2",
        content: "text-xs",
        confirmButton: "rounded-full px-4 py-1.5 text-xs font-medium",
      },
    });
  };

  const handleSidebarItemClick = (item) => {
    if (item === "학습 플랜") {
      navigate("/plan");
    } else if (item === "학습 대화") {
      navigate("/chat");
    } else if (item === "나의 책장") {
      navigate("/mybooks");
    }
    setIsSidebarOpen(false);
  };

  const agentMenuItems = [
    "고등수학 에이전트",
    "고등영어 에이전트",
    "고등국어 에이전트",
  ];

  const books = [
    {
      id: 1,
      title: "고등수학",
      image: img_book_math,
      description: "김혜진 외 · 도서출판 라이브데이터",
    },
    {
      id: 2,
      title: "고등 국어 문법",
      image: img_book_kor,
      description: "정성아 저 · 도서출판 라이브데이터",
    },
    {
      id: 3,
      title: "영어 독해",
      image: img_book_eng,
      description: "황태훈 저 · 도서출판 라이브데이터",
    },
  ];

  return (
    <Container>
      {/* 사이드바 오버레이 */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleSidebar}
        />
      )}

      {/* 사이드바 */}
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        currentAgent={currentAgent}
        nickname={nickname}
        handleLogout={handleLogout}
      />

      <MyBooksContainer>
        <div className="flex flex-row items-center justify-between px-2">
          <div className="flex items-center">
            <img
              src={HamburgerButton}
              alt="메뉴"
              className="w-4 h-4 cursor-pointer"
              onClick={toggleSidebar}
            />
          </div>
          <HeaderContent>
            <Title>나의 책장</Title>
          </HeaderContent>
          <div className="w-4"></div>
        </div>

        <BooksList>
          {books.map((book) => (
            <BookCard key={book.id}>
              <BookImage src={book.image} alt={book.title} />
              <BookInfo>
                <BookTitle>{book.title}</BookTitle>
                <BookDescription>{book.description}</BookDescription>
              </BookInfo>
            </BookCard>
          ))}
          <AddBookCard>
            <PlusIcon>+</PlusIcon>
          </AddBookCard>
        </BooksList>
      </MyBooksContainer>
    </Container>
  );
};

export default MyBooks;
